/**
 * Utility function to mask email address for display
 * Shows first and last character of local part with *** in between
 */
export const maskEmail = (email: string | undefined | null): string => {
  if (!email) return 'No email on file';

  const atIndex = email.indexOf('@');
  if (atIndex === -1) return email; // No @ symbol found

  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex);

  // If local part is too short (2 chars or less), don't mask
  if (localPart.length <= 2) {
    return email;
  }

  // Mask middle characters with ***
  const firstChar = localPart[0];
  const lastChar = localPart[localPart.length - 1];
  return `${firstChar}***${lastChar}${domain}`;
};
